import { OpenInNew } from '@mui/icons-material';
import { Input } from '@on3/ui-lib/components/Input/Input';
import { Link } from '@on3/ui-lib/components/Link';
import { filterNumber } from '@on3/ui-lib/utils/filters';
import { ProfileDetailsContext } from 'components/Modals/Player/Details';
import { useContext } from 'react';

import styles from './DetailsNcaa.module.scss';

export const DetailsNcaa = () => {
  const { values, errors, handleUpdate } = useContext(ProfileDetailsContext);

  return (
    <div className={styles.block}>
      <Input
        error={errors['ncaaId.value']}
        helperText={
          <Link href="https://web3.ncaa.org/ecwr3/">
            Get your NCAA ID <OpenInNew />
          </Link>
        }
        inputMode="numeric"
        label="NCAA ID"
        name="ncaaId"
        onChange={(e) =>
          handleUpdate(
            'ncaaId.value',
            filterNumber(e.target.value).slice(0, 10),
          )
        }
        value={values.ncaaId.value ?? ''}
      />
    </div>
  );
};
